import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Layout from './Layout';
import { useAuth } from '../hooks/useAuth';

const ProtectedLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role, loading, error } = useAuth();
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    if (!token || error) {
      localStorage.removeItem('authToken');
      navigate('/auth');
    }
  }, [token, error, navigate]);

  // Show loading while validating
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
          <p className="mt-4 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If not valid, don't render anything (navigation will happen)
  if (!token || error || !role) {
    return null;
  }

  // Render layout with outlet for child routes
  return (
    <Layout>
      <div
        key={location.pathname}
        className="animate-fadeIn"
      >
        <Outlet />
      </div>
    </Layout>
  );
};

export default ProtectedLayout;
